.container {
  justify-content: center;
  align-items: center;
  background-image: url(src/assets/images/image-background.png);
  background-repeat: no-repeat;
  background-size: contain;
}

.container-small {
  border-radius: 12px;
  width: 40px;
  height: 40px;
  backdrop-filter: blur(64px);

}

.container-medium {
  border-radius: 28px;
  width: 96px;
  height: 96px;
}


.container-large {
  border-radius: 36px;
  backdrop-filter: blur(96px);
  width: 128px;
  height: 128px;
}

.image {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.image-large {
}

.image-medium {
}

.image-small {
}
